import { useState } from "react";

import { ModelsSwitchImage, SectionProps } from "@/types";

import {
  switchImageVariant,
  type SwitchImageVariantProps,
} from "./switch-image.variants";

export type UseSwitchImageProps = SwitchImageVariantProps &
  SectionProps<ModelsSwitchImage>;

export const useSwitchImage = (props: UseSwitchImageProps) => {
  const { className = "", data, sectionName } = props;
  const { image1, image2, defaultValue } = data;

  const [checked, setChecked] = useState(defaultValue);

  const handleChange = (checked: boolean) => {
    setChecked(checked);
  };

  const styles = switchImageVariant();

  const image = checked ? image2 : image1;

  return {
    className,
    styles,
    sectionName,
    data: { ...data, image },
    checked,
    onChange: handleChange,
  };
};
